import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ErzeugungsanlageListItem } from '../../domain/model/erzeugungsanlage';
import { NetzbetreiberType } from '../../domain/model/netzbetreibertype';
import { RoutingService } from '../../service/common/routing/routing.service';
import { Sort, SortDirection } from '@angular/material/sort';

@Component({
    selector: 'redispatch-erzeugungsanlage-table',
    templateUrl: './erzeugungsanlage-table.component.html',
    styleUrls: [
        './erzeugungsanlage-table.component.scss',
    ],
    standalone: false,
})
export class ErzeugungsanlageTableComponent implements OnChanges {
    public static readonly DEFAULT_COLUMNS = [
        'dokumentenId',
        'resourceIds.steuerbareResourceId',
        'resourceIds.technischeResourceId',
        'bezVnbIntern',
        'netzzuordnung.ortsname',
        'netzzuordnung.stationsname',
        'netzzuordnung.trafoFeldName',
        'netzzuordnung.deactivated',
        'energietraeger',
        'leistung.bruttonennleistung',
    ];
    public static readonly ACTION_COLUMNS = [
        'anlage',
        'planwerte',
    ];

    public static readonly WESTNETZ_COLUMNS = [
        'netzzuordnung.netzbetreiber.name',
        'netzzuordnung.netzbetreiber.teilgebiet',
    ];

    @Input()
    public erzeugungsanlagen: ErzeugungsanlageListItem[];

    public columnsToDisplay = [];

    @Input()
    public netzbetreiberType: NetzbetreiberType;

    @Input()
    public sortDirection: SortDirection;

    @Input()
    public sortActive: string;

    @Output()
    public sortChange = new EventEmitter<Sort>();

    protected routingService = inject(RoutingService);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.netzbetreiberType) {
            this.netzbetreiberType = changes.netzbetreiberType.currentValue;
        }
        this.columnsToDisplay = this.generateColumnsToDisplay();
    }

    public get isWestnetz(): boolean {
        return this.netzbetreiberType && this.netzbetreiberType === 'WESTNETZ';
    }

    public _sortChange($event: Sort) {
        if ($event.direction === '') {
            $event.active = '';
        }
        this.sortChange.emit($event);
    }

    private generateColumnsToDisplay(): string[] {
        if (this.isWestnetz) {
            return [
                ...ErzeugungsanlageTableComponent.WESTNETZ_COLUMNS,
                ...ErzeugungsanlageTableComponent.DEFAULT_COLUMNS,
                ...ErzeugungsanlageTableComponent.ACTION_COLUMNS,
            ];
        }

        return [
            ...ErzeugungsanlageTableComponent.DEFAULT_COLUMNS,
            ...ErzeugungsanlageTableComponent.ACTION_COLUMNS,
        ];
    }
}
